import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as shvl from 'shvl';

const FALLBACK_LOCALE = '__default';

// 获取路径
VueI18n.prototype.rp = function (v, dataInject) {
  let path = v?.i18n;
  if (path === undefined) return [];
  if (typeof path === 'string') {
    path = path.split('.').filter((v) => v !== '');
  }
  if (!path?.length) return [];

  let p = [...path];
  let n = p[0];
  let o = dataInject?.[n];
  if (o) {
    do {
      p.shift();
      if (o.path !== undefined) {
        p.unshift(o.path);
      }
      if (o?.i18n === undefined || !o.i18n?.length) {
        break;
      }
      p = o.i18n.concat(p);
      n = p[0];
      o = dataInject[n];
    } while (o);
  }
  return p;
};

VueI18n.prototype.r = function (v, dataInject, defaultValue = '', locale) {
  locale = locale || i18n.locale;
  let p = i18n.rp(v, dataInject);
  if (p.length) {
    if (!i18n.te(p.join('.'), locale)) {
      v = defaultValue;
    } else {
      v = shvl.get(i18n.messages, [locale, ...p]);
    }
  } else {
    if (v?.i18n === undefined && v?.normal === undefined) {
      v = v ?? defaultValue;
    } else {
      v = v?.normal ?? defaultValue;
    }
  }
  return v;
};

VueI18n.prototype._warnDefault = function (locale, key, result, vm, values) {
  if (result !== null) {
    return result;
  }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (missingRet !== undefined) {
      return missingRet;
    }
  } else {
    if (
      process.env.NODE_ENV !== 'production' &&
      !this._isSilentTranslationWarn(key)
    ) {
      console.warn(
        "Cannot translate the value of keypath '" +
          key +
          "'. " +
          'Use the value of keypath as default.'
      );
    }
  }

  return key;
};

Vue.use(VueI18n);

let i18n = null;
const loadI18NLocaleMessage = (i18nMessage = {}) => {
  for (const [locale, message] of Object.entries(i18nMessage)) {
    i18n.setLocaleMessage(locale, message);
  }
};

const setI18NLocale = (locale) => {
  i18n.locale = locale;
};

export default ({ app, store }) => {
  app.i18n = new VueI18n({
    locale: FALLBACK_LOCALE,
    fallbackLocale: FALLBACK_LOCALE,
    messages: {},
    missing: function (locale, path) {
      return shvl.get(i18n.messages, `${locale}.${path}`);
    },
    fallbackRootWithEmptyString: false,
  });
  i18n = app.i18n;
};

export { i18n, FALLBACK_LOCALE, loadI18NLocaleMessage, setI18NLocale };
